export const PaymentService = {
  PAYMENT_TOKEN_2C2P: 'PAYMENT_TOKEN_2C2P',
  XENDIT_INVOICE: 'XENDIT_INVOICE',
  XENDIT_QR_CODE: 'XENDIT_QR_CODE',
  XENDIT_SUBSCRIPTION: 'XENDIT_SUBSCRIPTION',
  REVENUE_CAT: 'REVENUECAT',
} as const;

export type PaymentService =
  (typeof PaymentService)[keyof typeof PaymentService];

export const HostedPaymentPageServices = [
  PaymentService.XENDIT_INVOICE,
  PaymentService.PAYMENT_TOKEN_2C2P,
] as const;

export type HostedPaymentPageServices =
  (typeof HostedPaymentPageServices)[number];
